import { Tag } from 'lucide-react';
import { getPosCategoryIcon } from '@/constants/posCategoryIcons';
import { resolveFileUrl } from '@/utils/fileUrl';

interface Props {
  icon?: string | null;
  image?: string | null;
  color?: string | null;
  foreground?: string | null;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

const SIZE_MAP = {
  sm: { wrap: 'w-7 h-7', icon: 'w-4 h-4', img: 'w-5 h-5' },
  md: { wrap: 'w-10 h-10', icon: 'w-5 h-5', img: 'w-7 h-7' },
  lg: { wrap: 'w-12 h-12', icon: 'w-6 h-6', img: 'w-8 h-8' },
};

export default function CategoryIcon({ icon, image, color, foreground, size = 'md', className = '' }: Props) {
  const dims = SIZE_MAP[size];

  if (image) {
    return (
      <div
        className={`${dims.wrap} rounded-lg flex items-center justify-center overflow-hidden shrink-0 ${className}`}
        style={{ backgroundColor: color || '#f3f4f6' }}
      >
        <img src={resolveFileUrl(image)} alt="" className={`${dims.img} object-contain`} />
      </div>
    );
  }

  const IconComponent = getPosCategoryIcon(icon) || Tag;

  return (
    <div
      className={`${dims.wrap} rounded-lg flex items-center justify-center shrink-0 ${className}`}
      style={{ backgroundColor: color || '#f3f4f6' }}
    >
      <IconComponent
        className={`${dims.icon} ${foreground ? '' : 'text-gray-700'}`}
        style={foreground ? { color: foreground } : undefined}
      />
    </div>
  );
}
